import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { isNotUndefined, Product, ProductScope, ProductService } from '@spartacus/core';
import { filter, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CustomSimpleProductListData } from './custom-simple-product-list.model';

@Component({
  selector: 'app-custom-simple-product-list',
  templateUrl: './custom-simple-product-list.component.html',
  standalone: false
})
export class CustomSimpleProductListComponent {

  @Input() item: CustomSimpleProductListData;
  protected readonly PRODUCT_SCOPE = ProductScope.LIST;

  constructor(
    private componentData: CmsComponentData<CustomSimpleProductListData>,
    protected productService: ProductService,
    protected cd: ChangeDetectorRef,
  ) {
  }

  data$: Observable<CustomSimpleProductListData> = this.componentData.data$?.pipe(map((component) => {
    return { ...component, ...this.item };
  }));

  protected productCodes$: Observable<string[]> = this.data$?.pipe(map(data => data.products?.trim().split(' ')));

  products$: Observable<Observable<Product>[]> = this.productCodes$?.pipe(
    map((codes) =>
        codes?.map((code) => this.productService.get(code, this.PRODUCT_SCOPE)),
      map(filter(isNotUndefined))
    ),
  );
}
